import $ from 'jquery';
import {
  getWishlistItemData,
  isInWishlist,
  dispatchWishlistUpdate,
} from './helpers';

const selectors = {
  product: '[data-wishlist-product]',
  addButton: '[data-wishlist-add]',
};

const classes = {
  added: 'is-added',
};

const $wishlistProducts = $(selectors.product);
let currentWishlistItems = [];

/**
 * @param {jQuery} button
 * @param {Boolean} state
 */
function toggleButton(button, state = true) {
  button.toggleClass(classes.added, state);
  button.attr('aria-pressed', state);
}

/**
 * @param {Object} data
 */
function mapProps(data) {
  const {epi, du, empi, iu, pr, pt, stk, cprops, variants} = data;

  return {
    epi,
    du,
    empi,
    iu,
    pr,
    stk,
    pt,
    dt: pt,
    cprops,
    variants,
  };
}

/**
 * @param {jQuery} element
 */
function isAdded(element) {
  return element.hasClass(classes.added);
}

/**
 * @param {Object} data
 * @param {HTMLElement} target
 */
function toggleWishlist(data, target) {
  const payload = mapProps(data);
  const inWishlist = isAdded(target);

  window.SwymPageData.et = 4;

  if (inWishlist) {
    return window._swat.removeFromWishList(payload, () => {
      toggleButton(target, false);
      dispatchWishlistUpdate(target);
      currentWishlistItems = currentWishlistItems.filter(
        item => item.empi !== payload.empi,
      );
    });
  }

  return window._swat.addToWishList(payload, () => {
    toggleButton(target);
    dispatchWishlistUpdate(target);
    currentWishlistItems = [...currentWishlistItems, payload];
  });
}

/**
 * @param {Event} event
 */
function handleOptionChange(event) {
  const {variant, target} = event;
  const $target = $(target);

  if (variant === null || !variant.id) {
    target.removeAttribute('data-variant-id');
    target.removeAttribute('data-selected-options');
    checkButtonState($target);
    return;
  }

  target.setAttribute('data-variant-id', variant.id);
  target.setAttribute('data-selected-options', variant.options);
  checkButtonState($target);
}

/**
 * @param {Event} event
 */
function handleWishlistClick(event) {
  event.preventDefault();

  const $currentTarget = $(event.currentTarget);
  const $target = $(event.target);
  const $productCard = $target.closest(selectors.product);
  const data = getWishlistItemData($productCard);

  if (!data.empi) {
    return;
  }

  toggleWishlist(data, $currentTarget);
}

/**
 * @param {HTMLElement} $element
 */
function checkButtonState(element) {
  const $element = $(element);
  const $button = $element.find(selectors.addButton);
  const data = getWishlistItemData($element);
  const inWishlist = Boolean(isInWishlist(currentWishlistItems, data));

  $button.toggleClass('no-animate', inWishlist);
  toggleButton($button, inWishlist);
}

/**
 * @param {Object} products
 */
function fetchCallbackFn(products) {
  currentWishlistItems = products;
  $wishlistProducts.each((_, product) => checkButtonState(product));
  applyEventListeners();
}

function applyEventListeners() {
  $(document).on(
    'click.wishlist-card',
    selectors.addButton,
    handleWishlistClick,
  );
  $(document).on('optionsChange.product-grouped', handleOptionChange);
  $(document).on('optionsChange.product', handleOptionChange);
}

function productCallback() {
  if (!$wishlistProducts.length) {
    return;
  }

  window._swat.fetch(fetchCallbackFn, 4);
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

$(document).ready(function() {
  $('.scroll-to-ctl').on('click', function(event) {
    event.preventDefault();
    $('html, body').animate(
      { scrollTop: $(".scroll-target").offset().top-100},
      300, function() {
        const targetfocus = $(".scroll-target");
        targetfocus.attr('tabindex','-1');
        targetfocus.get(0).focus();
      }
    );
  });
});

window.SwymCallbacks.push(productCallback);
